<app-header [pages]=pages *ngIf="pages"></app-header>
<div class="loading-block" *ngIf="!pages" style="margin-top:60px;">
  <div class="progress-bar-load blue"></div>
  <div class="progress-bar-load"></div>
</div>
<div class="more" id="more"></div>
  <article>
		<div class="row">
      <!--colmenu-->
			<!-- <div class="col-md-3 offset-md-1 info">
				<ul class="filters">
					<li class="active"><a href="entrevistas">Entrevistas</a></li>
				</ul>
			</div> -->
      <!--colcontent-->
			<div class="col-md-10 offset-md-1">
        <app-interview-grid [entrevistas]="entrevistas" [single]="single"></app-interview-grid>
			</div>
		</div>
</article>
